/**
 * 사진 업로드 — 서버에서 표를 받아 **S3에 직접** 보낸다.
 *
 *   ① POST {ticketPath}  → { url, fields, imageUrl }
 *   ② POST {url}  (multipart, fields + file)   ← 우리 서버를 지나지 않는다
 *   ③ imageUrl을 Pick에 담아 저장
 *
 * ②가 실패해도 ③을 하지 않으면 고아 파일이 남을 뿐 잘못된 Pick은 안 생긴다.
 */

import type { ImageTicketResponse, UploadableImageType } from '@lifetimeline/shared';

import { api } from './apiClient.js';

/** Pick 사진과 프로필 사진은 표 발급 주소가 다르다. 키 규칙은 같다 */
export const PICK_IMAGE_TICKET = '/api/me/picks/image-ticket';
export const PROFILE_IMAGE_TICKET = '/api/me/image-ticket';

export async function uploadImage(
  blob: Blob,
  contentType: UploadableImageType,
  ticketPath: string = PICK_IMAGE_TICKET,
): Promise<string> {
  const ticket = await api.post<ImageTicketResponse>(ticketPath, {
    contentType,
  });

  const form = new FormData();
  for (const [name, value] of Object.entries(ticket.fields)) {
    form.append(name, value);
  }
  // ⚠️ 파일은 **맨 마지막**이다. S3는 file 앞에 온 필드만 정책과 대조하므로
  //    순서가 바뀌면 서명은 맞는데 거부당한다.
  form.append('file', blob);

  const response = await fetch(ticket.url, { method: 'POST', body: form });
  if (!response.ok) {
    throw new Error(`사진을 올리지 못했습니다 (${response.status})`);
  }
  return ticket.imageUrl;
}
